export class GetAudits {
    static readonly type = '[Audit] Get Audits';
    constructor(public payload: { gridUUID: string }) {}
}

export class ViewAudit {
    static readonly type = '[Audit] View Audit';
    constructor(public payload: { gridUUID: string }) {}
}